import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { registerUser, getFrontendErrorMessage } from 'utils/firebaseFunction';
import { useNavigate } from 'react-router';
import { MainContext } from 'utils/context';
import { TailSpin } from "react-loader-spinner";

export default function Register() {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputRegisterUser, setInputRegisterUser] = useState({
    username: "",
    email: "",
    password: "",
    addQuiz: [] // Array to store quizzes
  });

  const { user } = useContext(MainContext); // Using MainContext
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputRegisterUser({
      ...inputRegisterUser,
      [name]: value
    });
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const { username, email, password } = inputRegisterUser;
  
    if (!username || !email || !password) {
      setError("All fields are required.");
      return;
    }
  
    if (!validateEmail(email)) {
      setError("Invalid email address.");
      return;
    }
  
    setIsLoading(true); // Start loading
    const result = await registerUser(username, email, password);
    setIsLoading(false); // Stop loading
  
    if (result.success) {
      navigate("/"); // Redirect to the home page after registration
    } else {
      setError(getFrontendErrorMessage(result.error));
    }
  };
  return (
    <form className="form" onSubmit={handleRegister}>
      {error && <div className="error-message">{error}</div>}
      
      {/* Name Field */}
      <div className="form--flex-column">
        <label>Name</label>
      </div>
      <div className="form--inputForm">
        <svg height={60} viewBox="0 -9 32 32" width={40} xmlns="http://www.w3.org/2000/svg" aria-label="Username">
          <g id="Layer_3" data-name="Layer 3">
            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
          </g>
        </svg>
        <input
          type="text"
          name="username"
          className="form--input"
          placeholder="Enter your Name"
          value={inputRegisterUser.username}
          onChange={handleInputChange}
        />
      </div>
  
      {/* Email Field */}
      <div className="form--flex-column">
        <label>Email</label>
      </div>
      <div className="form--inputForm">
        <svg height={20} viewBox="0 0 32 32" width={20} xmlns="http://www.w3.org/2000/svg" aria-label="Email">
          <g id="Layer_3" data-name="Layer 3">
            <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z" />
          </g>
        </svg>
        <input
          type="text"
          name="email"
          className="form--input"
          placeholder="Enter your Email"
          value={inputRegisterUser.email}
          onChange={handleInputChange}
        />
      </div>
  
      {/* Password Field */}
      <div className="form--flex-column">
        <label>Password</label>
      </div>
      <div className="form--inputForm">
        <svg height={20} viewBox="-64 0 512 512" width={20} xmlns="http://www.w3.org/2000/svg" aria-label="Password">
          <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0" />
          <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0" />
        </svg>
        <input
          type="password"
          name="password"
          className="form--input"
          placeholder="Enter your Password"
          value={inputRegisterUser.password}
          onChange={handleInputChange}
        />
      </div>
  
      {/* Submit Button */}
      <button className="Btn form--button-submit" type="submit" disabled={isLoading}>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
            <TailSpin
              visible={true}
              height="20"
              width="20"
              color="#fff"
              ariaLabel="tail-spin-loading"
              radius="1"
            />
            <span>Creating account...</span>
          </div>
        ) : (
          "Register"
        )}
      </button>
    </form>
  );
}